export const ROLE_ENUMS = {
  ADMIN: {
    ROLE_ID: 1,
    ROLE_NAME: "ADMIN",
    ROLE_CODE: "ADMIN",
  },
  USER: {
    ROLE_ID: 2,
    ROLE_NAME: "USER",
    ROLE_CODE: "USER",
  },
};

export const SCREEN = {
  LOGIN: {
    NAME: "Login",
    PATH: "/login",
  },
  RESET_PASS: {
    NAME: "ResetPassword",
    PATH: "/reset-password",
  },
  HOME: {
    NAME: "Home",
    PATH: "/",
  },
  ERR403: {
    NAME: "Error403",
    PATH: "/403",
  },
  ERR404: {
    NAME: "Error404",
    PATH: "*",
  },
  TEST: {
    NAME: "Test",
    PATH: "/test",
  },
  CLASSIFICATION_REPORT: {
    NAME: "ClassificationReport",
    PATH: "/classification-report",
  },
  AGGREGATION_CORRECTION_REPORT: {
    NAME: "AggregationCorrectionReport",
    PATH: "/aggregation-correction-report",
  },
};

export const MENU_HOME = [
  {
    icon: "mdi-text-box-check-outline",
    title: "pageHome.test1",
    path: SCREEN.TEST.PATH,
    authorities: [ROLE_ENUMS.ADMIN.ROLE_CODE, ROLE_ENUMS.USER.ROLE_CODE],
  },
  {
    icon: "mdi-chart-bar-stacked",
    title: "pageHome.classificationReport",
    path: SCREEN.CLASSIFICATION_REPORT.PATH,
    authorities: [ROLE_ENUMS.ADMIN.ROLE_CODE, ROLE_ENUMS.USER.ROLE_CODE],
  },
  {
    icon: "mdi-text-box-check-outline",
    title: "pageHome.test3",
    path: SCREEN.TEST.PATH,
    authorities: [ROLE_ENUMS.ADMIN.ROLE_CODE, ROLE_ENUMS.USER.ROLE_CODE],
  },
  {
    icon: "mdi-chart-bar-stacked",
    title: "pageHome.aggregationCorrectionReport",
    path: SCREEN.AGGREGATION_CORRECTION_REPORT.PATH,
    authorities: [ROLE_ENUMS.ADMIN.ROLE_CODE, ROLE_ENUMS.USER.ROLE_CODE],
  },
];
